


















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DataUtility from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
import RujukanRalanSvc from "@/services/SuratRujukanRalan";
import { getHumanDateTime } from "@/utility/DateUtils";
import { SaranUnitTujuan, SuratRujukanRalanItem } from "@/types";

interface FaskesPilihan {
  id: string;
  nama: string;
  address?: string;
}

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalRujukan extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() readonly rm!: string;
  @Prop({ default: null }) readonly rujukan!: SuratRujukanRalanItem | null;
  @Prop({ default: null }) readonly sumberGenerate!: SuratRujukanRalanItem | null;

  isReadOnly!: () => boolean;

  valid = true;
  wajib = [v => (!!v && String(v).trim() !== "") || "*Kolom ini harus diisi"];
  listFaskes: FaskesPilihan[] = [];
  klinikRsps: string[] = [];
  saranUnit: SaranUnitTujuan = { faskes: [], umum: [] };
  memuatSaranUnit = false;
  tokenSaran = 0;
  cariFaskes = "";
  cariUnit: string | null = null;
  tujuan: FaskesPilihan | null = null;
  unit_tujuan_text = "";
  diagnosis = "";
  alasan = "";
  kondisi = "";
  terapi_diberikan = "";
  penunjang = "";
  terapi_diharapkan = "";
  dokter_id: number | null = null;
  saving = false;

  mounted() {
    this.muatFaskes();
    this.muatKlinikRsps();
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get isUserDokter() {
    return userModule.user?.profesi == "Dokter";
  }

  get isPenandaTangan() {
    return !!this.dokter_id && Number(this.dokter_id) === Number(userModule.user?.id);
  }

  get namaDokterTerpilih() {
    const dokter = (this.listDokter || []).find(d => Number(d.id) === Number(this.dokter_id));
    return dokter ? dokter.nama : "";
  }

  get mengubahSuratBerTtd() {
    return !!this.rujukan && Number(this.rujukan.signed) === 1;
  }

  get keteranganGenerate() {
    const s = this.sumberGenerate;
    if (!s) {
      return "Belum ada surat rujukan sebelumnya untuk pasien ini";
    }
    return `Salin isi Surat Rujukan ${getHumanDateTime(s.waktu)} ke ${s.tujuan?.nama || "-"}`;
  }

  get itemsFaskes(): FaskesPilihan[] {
    const terpilih = this.tujuan;
    if (terpilih && !this.listFaskes.some(f => String(f.id) === String(terpilih.id))) {
      return [terpilih, ...this.listFaskes];
    }
    return this.listFaskes;
  }

  get itemsUnit() {
    const kunci: Record<string, boolean> = {};
    const faskes: string[] = [];
    const lain: string[] = [];
    this.saranUnit.faskes.forEach(nama => {
      const k = nama.toLowerCase();
      if (nama && !kunci[k]) {
        kunci[k] = true;
        faskes.push(nama);
      }
    });
    this.saranUnit.umum.concat(this.klinikRsps).forEach(nama => {
      const k = (nama || "").toLowerCase();
      if (nama && !kunci[k]) {
        kunci[k] = true;
        lain.push(nama);
      }
    });
    const items: Array<string | { header?: string; divider?: boolean }> = [];
    if (faskes.length) {
      items.push({ header: "Pernah dipakai untuk faskes ini" }, ...faskes);
    }
    if (lain.length) {
      if (items.length) {
        items.push({ divider: true });
      }
      items.push({ header: faskes.length ? "Lainnya" : "Pilihan klinik/unit" }, ...lain);
    }
    return items;
  }

  get input() {
    return {
      type: "ralan",
      pasien_rm: this.rm,
      register_id: this.register,
      tujuan_id: this.tujuan?.id,
      tujuan_nama: this.tujuan?.nama,
      unit_tujuan_text: this.unit_tujuan_text,
      dokter_id: this.dokter_id,
      unit_id: userModule.user.unit_id,
      diagnosis: this.diagnosis,
      alasan: this.alasan,
      kondisi: this.kondisi,
      terapi_diberikan: this.terapi_diberikan,
      terapi_diharapkan: this.terapi_diharapkan,
      penunjang: this.penunjang
    };
  }

  @Watch("value", { immediate: true })
  onDibuka(val: boolean) {
    if (val) {
      this.isiForm();
    }
  }

  @Watch("tujuan")
  onTujuanBerubah() {
    if (this.value) {
      this.muatSaranUnit();
    }
  }

  @Watch("unit_tujuan_text")
  onUnitBerubah(val) {
    if (val && typeof val === "object") {
      this.unit_tujuan_text = val.text || "";
    }
  }

  faskesDariRujukan(r: SuratRujukanRalanItem | null): FaskesPilihan | null {
    return r && r.tujuan && r.tujuan.id ? { id: String(r.tujuan.id), nama: r.tujuan.nama || "" } : null;
  }

  isiForm() {
    const r = this.rujukan;
    this.cariUnit = null;
    if (r) {
      this.tujuan = this.faskesDariRujukan(r);
      this.unit_tujuan_text = r.unit_tujuan_text || "";
      this.diagnosis = r.diagnosis || "";
      this.alasan = r.alasan || "";
      this.kondisi = r.kondisi || "";
      this.terapi_diberikan = r.terapi_diberikan || "";
      this.penunjang = r.penunjang || "";
      this.terapi_diharapkan = r.terapi_diharapkan || "";
      this.dokter_id = r.dokter && r.dokter.id ? Number(r.dokter.id) : null;
    } else {
      const soap = storeSoap.detailSoap && storeSoap.detailSoap[0];
      this.tujuan = null;
      this.unit_tujuan_text = "";
      this.diagnosis = this.isUserDokter && soap ? soap["a"] || "" : "";
      this.alasan = "";
      this.kondisi = "";
      this.terapi_diberikan = "";
      this.penunjang = "";
      this.terapi_diharapkan = "";
      this.dokter_id = this.isUserDokter ? Number(userModule.user.id) : null;
    }
    this.muatSaranUnit();
    this.$nextTick(() => {
      const form = this.$refs.form as Vue & { resetValidation: () => void };
      if (form) {
        form.resetValidation();
      }
    });
  }

  generateDariSebelumnya() {
    const s = this.sumberGenerate;
    if (!s || this.readOnly) return;
    const adaIsian = [
      this.tujuan,
      this.unit_tujuan_text,
      this.diagnosis,
      this.alasan,
      this.kondisi,
      this.terapi_diberikan,
      this.penunjang,
      this.terapi_diharapkan
    ].some(v => !!v && (typeof v !== "string" || v.trim() !== ""));
    const label = `${getHumanDateTime(s.waktu)} ke ${s.tujuan?.nama || "-"}`;
    if (adaIsian && !confirm(`Isian form akan ditimpa dengan Surat Rujukan ${label}. Lanjutkan?`)) {
      return;
    }
    this.tujuan = this.faskesDariRujukan(s);
    this.cariUnit = null;
    this.unit_tujuan_text = s.unit_tujuan_text || "";
    this.diagnosis = s.diagnosis || "";
    this.alasan = s.alasan || "";
    this.kondisi = s.kondisi || "";
    this.terapi_diberikan = s.terapi_diberikan || "";
    this.penunjang = s.penunjang || "";
    this.terapi_diharapkan = s.terapi_diharapkan || "";
    appModule.NoticeDelay(`Isi Surat Rujukan ${label} disalin. Periksa & sesuaikan sebelum disimpan.`);
  }

  muatFaskes() {
    DataUtility.getListFaskes().then(faskes => {
      this.listFaskes = Array.isArray(faskes) ? faskes.map(f => ({ ...f, id: String(f.id) })) : [];
    });
  }

  muatKlinikRsps() {
    DataUtility.getListUnitRalanPagi().then(unit => {
      this.klinikRsps = Array.isArray(unit) ? unit.map(u => u && u.nama).filter(n => !!n) : [];
    });
  }

  async muatSaranUnit() {
    const token = ++this.tokenSaran;
    this.memuatSaranUnit = true;
    try {
      const resp = await RujukanRalanSvc.saranUnitTujuan(this.tujuan?.id);
      if (token !== this.tokenSaran) return;
      const data = resp && resp.data && resp.data.data;
      this.saranUnit = {
        faskes: data && Array.isArray(data.faskes) ? data.faskes : [],
        umum: data && Array.isArray(data.umum) ? data.umum : []
      };
    } catch {
      if (token === this.tokenSaran) {
        this.saranUnit = { faskes: [], umum: [] };
      }
    } finally {
      if (token === this.tokenSaran) {
        this.memuatSaranUnit = false;
      }
    }
  }

  async save() {
    if (this.readOnly || this.saving) return;
    const ketikan = (this.cariUnit || "").trim();
    if (ketikan && ketikan !== this.unit_tujuan_text) {
      this.unit_tujuan_text = ketikan;
    }
    await this.$nextTick();
    const form = this.$refs.form as Vue & { validate: () => boolean };
    if (form && !form.validate()) return;

    this.saving = true;
    try {
      const tandatangani = this.isPenandaTangan;
      const resp =
        this.rujukan && this.rujukan.id
          ? await RujukanRalanSvc.update(this.rujukan.id, this.input)
          : await RujukanRalanSvc.create(this.input);

      if (resp.data.status == 1) {
        this.$emit("saved", { data: resp.data.data, tandatangani });
        this.dialog = false;
      }
    } finally {
      this.saving = false;
    }
  }
}
